import { CSSProperties, useCallback } from "react"

import { DeviceType } from "./ToggleDeviceButtonGroup"
import { IFrame } from "../../../../../widgets/IFrame"

export const ResponsiveCanvas = ({ deviceType, children }: {
    deviceType: DeviceType,
    children?: React.ReactNode
}) => {
    const getDisplayModeStyle = useCallback((): CSSProperties => {
        switch (deviceType) {
            case DeviceType.Desktop:
                return { width: '1024px' }
            case DeviceType.Tablet:
                return { width: '768px' }
            case DeviceType.Mobile:
                return { width: '375px' }
            default:
                return {}
        }
    }, [deviceType])

    return <div className="responsive-canvas bg-gray-700">
        <IFrame title={deviceType} style={getDisplayModeStyle()} className="responsive-canvas-iframe">
            {children}
        </IFrame>
    </div>
}
